// utils/themeUtils.ts
export const applyBodyClass = (className?: string | null) => {
    if (!className) {return;}
    if (typeof document !== "undefined" && !document.body.classList.contains(className)) {
        document.body.classList.add(className);
    }
};

export const removeBodyClass = (className?: string | null) => {
    if (!className) {return;}
    if (typeof document !== "undefined" && document.body.classList.contains(className)) {
        document.body.classList.remove(className);
    }
};
